function regionFromLocale(locale) {
  const code = locale.split('-')[1];
  return code && code.toUpperCase();
}
function languageFromLocale(locale) {
  return locale.split('-')[0].toLowerCase();
}

export { languageFromLocale, regionFromLocale };
